import store from '../../store'
import LocalStorageService from '@/services/local-storage.service'
import TokenService from '@/services/token.service'

export default async (to, from, next) => {
	const hostName = () => {
		return window.location.hostname || 'localhost'
	}
	const protocol = () => {
		return window.location.protocol || 'http'
	}
	const deviceId = () => {
		return TokenService.getDeviceIdFromStorage()
	}
	const externalLoginUrl = () => {
		return `${protocol()}//${hostName()}/oauth?device-id=${deviceId()}&redirect_url=${protocol()}//${hostName()}${
			process.env.VUE_APP_PUBLIC_PATH
		}oauth2-callback`
	}
	if (!store.getters['auth/isAuthenticated']) {
		if (!store.getters['settings/login']) {
			await store.dispatch('settings/getLoginSettings')
		}
		if (store.getters['settings/login'].external_login === 1) {
			window.location.href = externalLoginUrl()
		}
		LocalStorageService.set('initRoute', to.fullPath)
		return next('/auth')
	}
	return next({ meta: { layout: 'auth' } })
}
